<script lang="ts" setup>
defineProps({
  title: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
});
defineEmits(['click']);
</script>

<template>
  <button
    :class="['burger-btn', { 'burger-btn--cross': isOpen }]"
    :title
    aria-label="menu button"
    type="button"
    @click="$emit('click')"
  >
    <i />
    <i />
    <i />
  </button>
</template>

<style lang="scss" scoped>
.burger-btn {
  flex-direction: column;

  i {
    display: block;
    width: 17px;
    height: 1px;
    margin-bottom: 5px;
    background-color: $black;
    transition:
      opacity 0.3s,
      transform 0.3s;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &--cross {
    i:nth-child(1) {
      transform: translate(1px, 6px) rotate(45deg);
    }

    i:nth-child(2) {
      opacity: 0;
      visibility: hidden;
    }

    i:nth-child(3) {
      transform: translate(1px, -6px) rotate(-45deg);
    }
  }
}
</style>
